export default "/images/737f1567244862a62371387206ad7a95.avif";